import { controls, grouped } from "../controls";
const agri_loan_applications = {
  label: "Agri Loan Applications",
  pageLabel: "Agri Loan Applications", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Application Number" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "application_number", maxlength: 36 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Season" }),
    ...controls.oc({ tab: "filter", c: "Season", placeHolder: "Season Code", name: "AgriLoanApplication-season-season_code", fastpath: "seasons" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AgriLoanApplication-season-season_display" }),
    ...controls.displayText({ tab: "filter", label: "Hangam" }),
    ...controls.oc({ tab: "filter", c: "Hangam", placeHolder: "Hangam Code", name: "AgriLoanApplication-hangam-hangam_code", fastpath: "hangams" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AgriLoanApplication-hangam-hangam_display" }),
    ...controls.displayText({ tab: "filter", label: "Member" }),
    ...controls.oc({ tab: "filter", c: "Member", placeHolder: "Member", name: "AgriLoanApplication-member-member", fastpath: "members" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "AgriLoanApplication-member-member" }),
    ...controls.displayText({ tab: "filter", label: "Code" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "agri_loan_application_code", maxlength: 30 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Description" }),
    ...controls.text({ tab: "filter", placeHolder: "", name: "agri_loan_application_display", width: "col-sm-4", maxlength: 100 }),
  ]
  , form: [

    ...grouped.trnsummary(),

    {
      widths: "col-sm-9",
      tab: "general",
      style: { marginTop: 5, border: 0, paddingLeft: 0, paddingRight: 0 },
      direction: 'vertical',
      pagination: { perPage: 30, buttonSize: 'col-sm-2' },
      subComponents: [
        ...controls.displayText({ tab: "general", label: "Application Number", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "application_number", isRequired: false, maxlength: 36 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Season", star: false }),
        ...controls.oc({ tab: "general", c: "Season", placeHolder: "Season Code", name: "season_code", isRequired: false, fastpath: "seasons" }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "season_display" }),
        ...controls.displayText({ tab: "general", label: "Hangam", star: false }),
        ...controls.oc({ tab: "general", c: "Hangam", placeHolder: "Hangam Code", name: "hangam_code", isRequired: false, fastpath: "hangams" }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "hangam_display" }),
        ...controls.displayText({ tab: "general", label: "Member", star: false }),
        ...controls.oc({ tab: "general", c: "Customer", placeHolder: "Member", name: "customer_code", isRequired: false, fastpath: "customers", displayData: { gender: "gender", pan: "pan", aadhaar: "aadhaar", mothers_name: "mothers_name", religion: "religion", caste: "caste", mobile: "mobile" } }),
        ...controls.showData({ tab: "general", displaytype: "capital", data: "customer_display" }),
        ...controls.displayText({ tab: "general", label: "Code", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "agri_loan_application_code", isReadOnly: true, maxlength: 30 }),
        ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
        ...controls.displayText({ tab: "general", label: "Description", star: false }),
        ...controls.text({ tab: "general", placeHolder: "", name: "agri_loan_application_display", isRequired: false, width: "col-sm-4", maxlength: 100 }),
        {
          widths: "col-sm-12",
          tab: "general",
          title: "Pacs Applications",
          subComponents: [

            {
              widths: "col-sm-12",
              tab: "general",
              style: { border: 0, paddingLeft: 0, paddingRight: 0 },
              direction: 'vertical',
              pagination: { perPage: 30, buttonSize: 'col-sm-2' },
              subComponents: [
                ...controls.displayText({ tab: "general", label: "Loan Type", star: false }),
                ...controls.oc({ tab: "general", c: "LoanType", placeHolder: "Loan Type Code", name: "loan_type_code", isRequired: false, fastpath: "loan_types" }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "loan_type_display" }),
                ...controls.displayText({ tab: "general", label: "Product", star: false }),
                ...controls.oc({ tab: "general", c: "Product", placeHolder: "Product Code", name: "product_code", isRequired: false, fastpath: "products" }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "product_display" }),
                ...controls.displayText({ tab: "general", label: "Crop", star: false }),
                ...controls.oc({ tab: "general", c: "Crop", placeHolder: "Crop Code", name: "crop_code", isRequired: false, fastpath: "crops" }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "crop_display" }),
                ...controls.displayText({ tab: "general", label: "Land Type", star: false }),
                ...controls.oc({ tab: "general", c: "LandType", placeHolder: "Land Type Code", name: "land_type_code", isRequired: false, fastpath: "land_types" }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "land_type_display" }),
                ...controls.displayText({ tab: "general", label: "Unit", star: false }),
                ...controls.oc({ tab: "general", c: "Unit", placeHolder: "Unit Code", name: "unit_code", isRequired: false, fastpath: "units" }),
                ...controls.showData({ tab: "general", displaytype: "capital", data: "unit_display" }),
                ...controls.displayText({ tab: "general", label: "Land Area" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "land_area", maxlength: 10 }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Insurance" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "insurance", maxlength: 18, isReadOnly: true }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Max Amount" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "max_amount", maxlength: 18, isReadOnly: true }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Application Amount" }),
                ...controls.floatOnly({
                  tab: "general", placeHolder: "", name: "application_amount", maxlength: 18,
                  parents: [
                    {
                      name: "agri_loan_application_code",
                      match: "exist",
                      reverse: true,
                      show: 'readonly'
                    }
                  ]
                }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Secretary Amount" }),
                ...controls.floatOnly({
                  tab: "general", placeHolder: "", name: "secretary_amount", maxlength: 18,
                  parents: [
                    {
                      name: "agri_loan_application_code",
                      match: "exist",
                      reverse: true,
                      show: 'readonly'
                    }
                  ]
                }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Inspector Amount" }),
                ...controls.floatOnly({
                  tab: "general", placeHolder: "", name: "inspector_amount", maxlength: 18,
                  parents: [
                    {
                      name: "agri_loan_application_code",
                      match: "exist",
                      show: 'readonly'
                    }
                  ]
                }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "general", label: "Bank Sanction Amount" }),
                ...controls.floatOnly({ tab: "general", placeHolder: "", name: "bank_sanction_amount", maxlength: 18, isReadOnly: true }),
                ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
                ...controls.displayText({ tab: "pacs_applications", width: "col-sm-12", label: "" }),
                ...controls.displayText({ tab: "pacs_applications", width: "col-sm-4", label: "" }),
                ...controls.button({
                  tab: "pacs_applications",
                  label: "ADD",
                  style: { padding: 0 },
                  Bcolor: "success",
                  onclick: {
                    action: "appendToHTMLTable",
                    tableNameField: "pacs_applications",
                    requiredField: ["loan_type_code", "loan_type_display", "loan_type_uid", "product_code", "product_display", "product_uid", "crop_code", "crop_display", "crop_uid", "land_type_code", "land_type_display", "land_type_uid", "unit_code", "unit_display", "unit_uid", "land_area", "insurance", "max_amount", "application_amount", "secretary_amount", "inspector_amount", "bank_sanction_amount",]
                  }, width: "col-sm-2"
                }),
                ...controls.button({
                  tab: "pacs_applications",
                  label: "CLEAR",
                  style: { padding: 0 },
                  Bcolor: "warning",
                  onclick: {
                    action: "clearForm",
                    tableNameField: "pacs_applications",
                    requiredField: ["loan_type_code", "loan_type_display", "loan_type_uid", "product_code", "product_display", "product_uid", "crop_code", "crop_display", "crop_uid", "land_type_code", "land_type_display", "land_type_uid", "unit_code", "unit_display", "unit_uid", "land_area", "insurance", "max_amount", "application_amount", "secretary_amount", "inspector_amount", "bank_sanction_amount",]
                  }, width: "col-sm-2"
                }),
              ]
            },
            {
              tab: "pacs_applications",
              inputType: "table",
              tableTitle: "",
              deletable: true,
              editable: true,
              tableHeaders: [
                { label: "Sr", type: "autoinc" },
                { label: "Loan Type Code", field: "loan_type_code" },
                { label: "Loan Type Display", field: "loan_type_display" },
                { label: "Product Code", field: "product_code" },
                { label: "Product Display", field: "product_display" },
                { label: "Crop Code", field: "crop_code" },
                { label: "Crop Display", field: "crop_display" },
                { label: "Land Type Code", field: "land_type_code" },
                { label: "Land Type Display", field: "land_type_display" },
                { label: "Unit Code", field: "unit_code" },
                { label: "Unit Display", field: "unit_display" },
                { label: "Land Area", field: "land_area" },
                { label: "Insurance", field: "insurance" },
                { label: "Max Amount", field: "max_amount" },
                { label: "Application Amount", field: "application_amount" },
                { label: "Secretary Amount", field: "secretary_amount" },
                { label: "Inspector Amount", field: "inspector_amount" },
                { label: "Bank Sanction Amount", field: "bank_sanction_amount" },
              ],
              widths: {
                parent: "col-sm-12",
                children: "col-sm-12"
              },
              name: "pacs_applications"
            },
          ]
        },

      ]
    }, grouped.customerinfo('general')]
  , history: {
    perPage: 10,
    reportHeader: "Agri Loan Applications",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Application Number", accessor: "application_number", },
      { Header: "Season", accessor: "AgriLoanApplication-season-season_display", },
      { Header: "Hangam", accessor: "AgriLoanApplication-hangam-hangam_display", },
      { Header: "Member", accessor: "AgriLoanApplication-member-member_display", },
    ]
  }
};
export default agri_loan_applications;